import { CrudStoreItem } from 'legacy/lut/classes/models/CrudStoreItem'

import { PartnerHierarchyType } from 'clickNgo/entities/partner/configs'
import { IPartner } from 'clickNgo/entities/partner/models'
import { Logic, Operator } from 'core-components/types'
import { CrudStore } from 'core/types/crudStore'

export const checkPossibilityChangeStatus = async (partner: IPartner): Promise<string> => {
  if (partner.workflowStatus || partner.legalWorkflowStatus) {
    return 'Partner cannot be inactivated. It has an active edit request'
  }

  if (partner.hasAgreements) {
    return 'Partner cannot be inactivated. It has an active Contract'
  }

  const isHQ = partner.hierarchyType === PartnerHierarchyType.HEADQUARTERS

  if (isHQ) {
    const crud = CrudStore.get(
      CrudStoreItem.PartnerAllData,
      `inactiveBranchesCheck-${partner.partnerId}`
    )
    crud.setFilter({
      logic: Logic.AND,
      filters: [
        {
          field: 'TopPartnerID',
          operator: Operator.EQUAL,
          value: partner.partnerId,
        },
        {
          logic: Logic.OR,
          filters: [
            {
              field: 'StatusExt',
              operator: Operator.EQUAL,
              value: 'Active',
            },
            {
              field: 'StatusExt',
              operator: Operator.ISNULL,
              value: '',
            },
          ],
        },
        {
          field: 'PartnerID',
          operator: Operator.NOTEQUAL,
          value: partner.partnerId,
        },
      ],
    })

    const result = await crud.fetch()

    if (result && result.items && result.items.length) {
      return 'Partner cannot be inactivated. It has active Branches'
    }
  }
  return ''
}
